export default "__VITE_ASSET__B2epMtS0__"